module.exports = __webpack_public_path__ + "img/BRIN.5fa3cc06.svg";